import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    currentPage:1
}
const agentListReducer = createSlice({
    name:'agentMethodsReducer',
    initialState,
    reducers:{
        setCurrentPage(state,action) { // 修改页数
            state.currentPage = action.payload
        }
    }
})

export const { setCurrentPage } = agentListReducer.actions

export default agentListReducer.reducer